((Drupal) => {
  Drupal.behaviors.nrwFilterModal = {
    attach: (context) => {

      const $fundingSearch = once('setFormAction', '.funding-search', context);
      const $elements =  once('filterModal', 'fieldset[data-collapsible] legend', context);

      $fundingSearch.forEach(($element) => {
        const $textfield = $element.querySelector('.form-text');
        const $button = $element.querySelector('.btn');

        const $url = (new URL(document.location));
        const $params = new URLSearchParams($url.search);
        const $search = $params.get('search');

        document.querySelector('.view-filter--funding-page [name="search"]').value = $search;

        $button.addEventListener('click', ($e) => {
          $e.preventDefault();
          document.querySelector('.view-filter--funding-page .btn').click();
        });

        $textfield.addEventListener('keyup', ($e) => {
          document.querySelector('.view-filter--funding-page [name="search"]').value = $e.currentTarget.value;
        });

        const $automation = $params.get('a');

        if ($automation === 'search') {
          document.querySelector('.glowing-form').classList.add('animate');
        }

        if ($automation === 'filter') {
          document.querySelector('.glowing-filter').classList.add('animate');
        }


      });

      $elements.forEach(($element) => {

        const $parent = $element.parentNode;
        Drupal.behaviors.nrwFilterModal.refreshCounter($parent, false);
        $parent.classList.add('filter-overlay');

        $element.addEventListener('click', ($event) => {

          let $nrwModal = Drupal.behaviors.nrwFilterModal.getModal();

          if ($($element).text().includes('Themenfelder')) {
            var filterTitle = 'Themenfelder';
          } else if ($($element).text().includes('Zielgruppen')) {
            var filterTitle = 'Zielgruppen';
          } else {
            var filterTitle = '';
          }

          if (!$nrwModal) { $nrwModal =  Drupal.behaviors.nrwFilterModal.initModal('filter-modal', false, filterTitle); }

          let content =  $parent.querySelectorAll('.fieldset-wrapper > .form-checkboxes');
          let titleValue = $parent.querySelector('legend');

          $nrwModal.setAttribute('data-element', $parent.getAttribute('id'));

          Drupal.behaviors.nrwFilterModal.setModalContent(titleValue.cloneNode(true), content[0].cloneNode(true), $parent);

          const myModal = new bootstrap.Modal($nrwModal);
          myModal.show($nrwModal);

          const myModalEl = document.getElementById('bs-modal')
          myModalEl.addEventListener('hidden.bs.modal', ($event) => {
            document.querySelector('.view-filter--funding-page .btn').click();
          })



        });
      });

    },
    refreshCounter: ($parent, $modalTitle) => {
      // Get active elements
      const $activeElements = $parent.querySelectorAll('input:checked');
      $parent.querySelector('.counter').innerHTML = $activeElements.length;

      if ($modalTitle) {
        $modalTitle.querySelector('.counter').innerHTML = $activeElements.length;
      }
    },
    // @Todo: Merge with link-extern-modal.js
    setModalContent: ($titleValue, $content, $parent) => {
      const $title = Drupal.behaviors.nrwFilterModal.getModal().querySelector('.modal-title')
      const $body = Drupal.behaviors.nrwFilterModal.getModal().querySelector('.modal-body');
      $content.querySelectorAll('input').forEach(($element) => {

        const $id = $element.getAttribute('id');

        $content.querySelector('[for=' + $id + ']')
          .setAttribute('for', 'temp--' + $id);
        $element.setAttribute('id', 'temp--' + $id);

        $element.addEventListener('change', ($event) => {
          document.getElementById($id).click();
          Drupal.behaviors.nrwFilterModal.refreshCounter($parent, $title);
        });

      });

      $title.innerHTML = '';
      $title.appendChild($titleValue)

      $body.innerHTML = '';
      $body.appendChild($content);
    },
    // @Todo: Merge with link-extern-modal.js
    getModal: () => {
      return document.getElementById('bs-modal');
    },
    // @Todo: Merge with link-extern-modal.js
    initModal: ($classes, $showFooter, filterTitle) => {

      if ($classes === undefined || $classes === false) {
        $classes = '';
      }

      let $modal = document.createElement('div');
      $modal.classList.add('modal', 'fade', $classes);
      $modal.setAttribute('id', 'bs-modal');
      $modal.setAttribute('tabindex', '-1');
      $modal.setAttribute('role', 'dialog');
      $modal.setAttribute('aria-labelledby', 'modalLabel');
      $modal.setAttribute('aria-hidden', 'true');

      // TODO: This is not good and really needs refactoring.
      if (filterTitle === 'Zielgruppen') {
        var buttonText = 'Zielgruppenfilter anwenden';
        var buttonReset = 'Alle Zielgruppenfilter entfernen';
      }
      if (filterTitle === 'Themenfelder') {
        var buttonText = 'Themenfeldfilter anwenden';
        var buttonReset = 'Alle Themenfeldfilter entfernen';
      }

      $modal.innerHTML = ' <div class="modal-dialog modal-dialog-centered">' +
        '          <div class="modal-content">' +
        '            <div class="modal-header">' +
        '              <h2 class="modal-title fs-5" id="modalLabel"></h2>' +
        '              <button type="button" class="btn fw-normal" data-bs-dismiss="modal" aria-label="' + Drupal.t('Close') + '">' + Drupal.t('Close') + '<i class="fa-solid fa-xmark btn-close ms-2"></i></button>' +
        '            </div>' +
        '            <div class="modal-body"></div>' +
        '            <div class="modal-footer"><hr>' +
        '              <button type="button" class="btn btn-white form-reset">' + Drupal.t(buttonReset) + '</button>' +
        '              <button type="button" class="btn btn-primary" data-apply-filter="true" data-bs-dismiss="modal">' + Drupal.t(buttonText) +'</button>' +
        '            </div>' +
        '          </div>' +
        '        </div>'
      // modal.innerHTML =
      //   '<div class="modal-dialog" role="document">' +
      //   '<div class="modal-content"></div>' +
      //   '</div>';

      const $resetButton = $modal.querySelector('.form-reset');

      $resetButton.addEventListener('click', ($event) => {
        $modal.querySelectorAll('.form-checkbox:checked').forEach(($checkbox) => {
          $checkbox.click();
        });
      });

      document.body.appendChild($modal);
      return $modal;
    }
  };
})(Drupal);
